import React from "react";
import styled from "styled-components";

function FlexCenterCenter(props) {
    const FlexCenterCenter = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    `;
  return (
    <FlexCenterCenter>
        {props.children}
    </FlexCenterCenter>
  );
}

export default FlexCenterCenter;
